import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { generateValidationSchema } from "./Validations";
import { useFormik } from "formik";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useLoginMutation } from "../State/Api/LoginApiSlice";
import { ToastContainer, toast } from 'react-toastify';
import TermsandConditions from "./ClinicModal/TermsandConditions";
import SubscriptionExpiredModal from "./ClinicModal/SubscriptionExpiredModal";


function SignIn() {
const quotes = [
    "We Made Your Medical Treatment Easy",
    "Your Health, Our Priority",
    "Caring for You, Every Step"
  ];
  const [showSubscriptionExpiredModal, setShowSubscriptionExpiredModal] = useState(false);
const [subscriptionExpiredMessage, setSubscriptionExpiredMessage] = useState("");
  const [displayText, setDisplayText] = useState("");
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [phase, setPhase] = useState("typing");
  const indexRef = useRef(0); 
  const quoteIndexRef = useRef(0);

  useEffect(() => {
    let timeout;
    const currentQuote = quotes[quoteIndexRef.current];

    if (phase === "typing") {
      if (indexRef.current < currentQuote.length) {
        timeout = setTimeout(() => {
          setDisplayText(currentQuote.slice(0, indexRef.current + 1));
          indexRef.current += 1;
        }, 100);
      } else {
        timeout = setTimeout(() => setPhase("erasing"), 1200);
      }
    } else if (phase === "erasing") {
      if (indexRef.current > 0) {
        timeout = setTimeout(() => {
          indexRef.current -= 1;
          setDisplayText(currentQuote.slice(0, indexRef.current));
        }, 70);
      } else {
        // Move to next quote
        quoteIndexRef.current = (quoteIndexRef.current + 1) % quotes.length;
        timeout = setTimeout(() => setPhase("typing"), 500);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayText, phase, quotes]);

  const expiryMessages = [
  "3 days left before your clinic plan expires.",
  "2 days left before your clinic plan expires.",
  "Your clinic plan expires today."
];

  const signinstyles=`
  
`
  const [showpass, setShowPass] = useState(false);
  const [login, { isSuccess, isError, isLoading, error }] = useLoginMutation();
  const navigate = useNavigate();
  const formFields = ["email", "password"];
  const validationSchema = generateValidationSchema(formFields);
  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => handleSubmit(values, { resetForm }),
  });
  const handleSubmit = async (value) => {
    try {
      if (value) {
        const result = await login({
          email: value.email,
          password: value.password,
        }).unwrap();

         if (result?.data?.message === "Your clinic subscription has expired. Please renew to continue using the system.") {
          setSubscriptionExpiredMessage(result.data.message);
          setShowSubscriptionExpiredModal(true);
          return;
        }
      
        if (result?.message === "Sign in successful" && result?.data.status === 1) {
          localStorage.setItem("userUniqueID", result?.data?.userUniqueID);
          localStorage.setItem("userClinicID", result?.data?.userClinicID);
          localStorage.setItem("roleid", result?.data?.roleid);

          localStorage.setItem("token", "c3ViYnVyZWFjdG5hdGl2ZWRldmVsb3Blcg==");
          const termsandconditions=result?.data?.termsandconditions;

           if (result?.data?.roleid === 2 && expiryMessages.includes(result?.data.message)) {
    navigate("/ClinicDashboard", { state: { showPlanExpiryModal: true, expiryMessage: result?.data.message } });
    return;
  }

  if (result?.data?.roleid === 3 && expiryMessages.includes(result?.data.message)) {
  navigate("/DoctorDashBoard", { state: { showPlanExpiryModal: true, expiryMessage: result?.data.message } });
  return;
}

        if (result?.data?.roleid === 1) {
          navigate("/Dashboard");
        } else if (result?.data?.roleid === 2  && result?.data?.termsandconditions ) {

          navigate("/ClinicDashboard");
        }else if(result?.data?.roleid === 2  && !result?.data?.termsandconditions){
            setShowTermsModal(true);
        }
        else if (result?.data?.roleid === 3) {
          navigate("/DoctorDashBoard");
        } else if (result?.data?.roleid === 4) {
          navigate("/PatientProfile");
        } else if (result?.data?.roleid === 5) {
          navigate("/DashboardOverview");
        }
        }
        else if( result?.data.status === 0){
          toast.error(result?.data.message);
        }
        
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };


  return (
    <>
    <style>{signinstyles}</style>
      <section
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          position: "relative",
        }}
        className="section-bg"
      >
        <div className="row">
          <div className="col-6">
            <div className="div-totLg0piuG">
              <form
                action=""
                className="form-ym5zR5QPwa"
                onSubmit={formik.handleSubmit}
              >
                <div className="d-flex flex-column align-items-center justify-content-center mb-4">
                  <div>
                    <img
                      src="./Images/pelican text logo 1.png"
                      style={{ width: "12rem" }}
                      alt=""
                      srcset=""
                    />
                  </div>
                  <br />
                  <span className="text-secondary" style={{ fontSize: "14px" }}>
                    Effortless healthcare starts with a simple sign-in. Welcome
                    to <strong>PelicanRX.</strong>
                  </span>
                </div>

                <hr className="mb-4" style={{ borderTop: "black 1px solid" }} />

                <div className="div-sxjsnjij9 mb-3">
                  <label
                    htmlFor=""
                    className="form-label fw-semibold"
                    style={{ fontSize: "14px" }}
                  >
                    Email Address
                  </label>
                  <input
                    className="form-control"
                    id="email"
                    name="email"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    placeholder="Email Address"
                    style={{ width: "100%", height: "2.5rem" }}
                  />

                  {formik.touched.email && formik.errors.email ? (
                    <div
                      style={{ fontSize: "0.8rem", color: "red" }}
                      className="lbl-P9urEIgWf1"
                    >
                      {formik.errors.email}
                    </div>
                  ) : null}
                </div>

                <div className=" div-sxjsnjij9 mb-3 position-relative">
                  <label
                    htmlFor=""
                    className="form-label fw-semibold"
                    style={{ fontSize: "14px" }}
                  >
                    Password
                  </label>
                  <input
                    className="form-control"
                    id="password"
                    name="password"
                    type={showpass ? "text" : "password"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    placeholder="Password"
                    style={{ width: "100%", height: "2.5rem" }}
                  />
                  <div
                    className="position-absolute"
                    style={{ top: "38px", right: "4px" }}
                  >
                    <button
                      className="show-btn lbl-P9urEIgWf1"
                      type="button"
                      style={{ background: "none" }}
                      onClick={() => setShowPass(!showpass)}
                    >
                      {showpass ? (
                        <Visibility
                          sx={{ fontSize: "20px", color: "#666666a8" }}
                        />
                      ) : (
                        <VisibilityOff
                          sx={{ fontSize: "20px", color: "#666666a8" }}
                        />
                      )}
                    </button>
                  </div>
                  {formik.touched.password && formik.errors.password ? (
                    <div
                      style={{ fontSize: "0.8rem", color: "red" }}
                      className="lbl-P9urEIgWf1"
                    >
                      {formik.errors.password}
                    </div>
                  ) : null}
                </div>

                <div className="text-end mb-4">
                  <button
                    type="button"
                    className="border-0 p-0"
                    style={{
                      background: "none",
                      color: "#0266D6",
                      textDecoration: "none",
                      fontSize: "12px",
                    }}
                    onClick={() => navigate("/ForgotPassword")}
                  >
                    Forgot Password?
                  </button>
                </div>

                <button className="gradient-dark-button w-100" type="submit">
                  {isLoading && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  {isLoading ? "Signing in…" : "Sign in"}
                </button>
                {isError && (
                  <span className="text-danger ms-1 mt-1">
                    Invalid Email or Password. Please try again.
                  </span>
                )}
              </form>
            </div>
          </div>
          <div className="col-6 div-hvuvuj">
            <div
              className="position-absolute "
              style={{ right: "12rem", top: "0" }}
            >
              <div
                style={{
                  backgroundColor: "#FFFFFF",
                  color: "#fff",
                  padding: "1rem",
                  position: "relative",
                  clipPath: "polygon(0 0, 100% 0, 100% 85%, 0 100%)",
                  textAlign: "center",
                  zIndex: "1",
                }}
              >
                {/* White Cross */}
                <div
                  style={{
                    marginBottom: "0.5rem",
                  }}
                >
                  <img
                    className="img-fluid"
                    style={{ width: "4rem" }}
                    src="/Images/pelican logo 2.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div
  className="position-absolute"
  style={{ top: "40%", left: "70%", transform: "translateX(-50%)" }}
>
  <div
      className="text-white fw-bold slide-in-heading"
      style={{ fontSize: "2.5rem", transition: "opacity 0.5s ease-in-out" }}
    >
      <h2 >
        {displayText}
        <span aria-hidden="true" />
      </h2>
    </div>
    </div>
          </div>
        </div>

        {/* <div className="img-V6fpDDVfc2">
          <img className="img-fluid" src="/Images/Pelican-sign.jpg" alt="" />
        </div> */}
      </section>
      
    <ToastContainer />
    <TermsandConditions showTermsModal={showTermsModal} setShowTermsModal={setShowTermsModal} />
    <SubscriptionExpiredModal
    show={showSubscriptionExpiredModal}
    message={subscriptionExpiredMessage}
    onClose={() => setShowSubscriptionExpiredModal(false)}
  />
    </>
  );
}

export default SignIn;
